import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    passwd: ""
  },
  mutations: {
    setPasswd(state, pwd) {
      state.passwd = `Bearer ${pwd}`;
    }
  }
});
